module.exports = __webpack_public_path__ + "static/media/overlap.8f63e508.svg";